import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";

const PrivacyPolicy = () => {
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  function getBaseDomain(hostname) {
    const parts = hostname.split(".");
    if (parts.length >= 2) {
      return parts.slice(-2).join(".");
    }
    return hostname;
  }
  const handleSubscribe = (e) => {
    e.preventDefault();

    if (!email.trim()) {
      setMessage("Please enter a valid email address.");
      return;
    }

    setMessage(
      "Thank you for subscribing! 🎉 You'll now receive our latest offers and updates."
    );
    setEmail("");
    setSubscribed(true);
  };
  return (
    <Container className="container mx-auto px-4 py-8 mt-3">
      <div>
        <h3 className="mb-4" style={{ fontWeight: 600, fontSize: "24px" }}>
          Privacy Policy
        </h3>

        <h3 className="mb-2" style={{ fontWeight: 600, fontSize: "24px" }}>
          Introduction
        </h3>
        <p className="mb-4">
          This Privacy Policy describes how{" "}
          {getBaseDomain(window.location.hostname)} and its affiliates
          (collectively "{getBaseDomain(window.location.hostname)}, we, our,
          us") collect, use, share, protect, or otherwise process your
          information/personal data through our website{" "}
          {getBaseDomain(window.location.hostname)} (hereinafter referred to as
          Platform).
        </p>
        <p className="mb-4">
          Please note that you may be able to browse certain sections of the
          Platform without registering with us. We do not offer any
          product/service under this Platform outside India, and your personal
          data will primarily be stored and processed in India. By visiting this
          Platform, providing your information, or availing of any
          product/service offered on the Platform, you expressly agree to be
          bound by the terms and conditions of this Privacy Policy, the Terms of
          Use, and the applicable service/product terms and conditions, and
          agree to be governed by the laws of India, including but not limited
          to the laws applicable to data protection and privacy. If you do not
          agree, please do not use or access our Platform.
        </p>

        <h3 className="mb-2" style={{ fontWeight: 600, fontSize: "24px" }}>
          Collection
        </h3>
        <p className="mb-4">
          We collect your personal data when you use our Platform, services, or
          otherwise interact with us during the course of our relationship and
          related information provided from time to time. Some of the
          information we may collect includes but is not limited to personal
          data/information provided to us during sign-up/registering or using
          our Platform, such as name, date of birth, address, telephone/mobile
          number, email ID, and/or any such information shared as proof of
          identity or address. Sensitive personal data such as payment
          information or biometric data may also be collected with your consent.
        </p>

        <h3 className="mb-2" style={{ fontWeight: 600, fontSize: "24px" }}>
          Usage
        </h3>
        <p className="mb-4">
          We use personal data to provide the services you request. To the
          extent we use your personal data to market to you, we will provide you
          the ability to opt-out of such uses. Other purposes include order
          handling, customer experience enhancement, fraud detection, marketing
          research, and compliance with legal obligations.
        </p>

        <h3 className="mb-2" style={{ fontWeight: 600, fontSize: "24px" }}>
          Sharing
        </h3>
        <p className="mb-4">
          We may share your personal data internally within our group entities
          and with third parties such as business partners, service providers,
          and law enforcement agencies, as necessary for providing services,
          marketing, compliance, or legal obligations.
        </p>

        <h3 className="mb-2" style={{ fontWeight: 600, fontSize: "24px" }}>
          Security Precautions
        </h3>
        <p className="mb-4">
          To protect your personal data from unauthorized access or misuse, we
          adopt reasonable security practices and procedures. However,
          transmission of information over the internet is not completely
          secure, and users are advised to ensure the protection of their
          account credentials.
        </p>

        <h3 className="mb-2" style={{ fontWeight: 600, fontSize: "24px" }}>
          Data Deletion and Retention
        </h3>
        <p className="mb-4">
          You can delete your account through the Platform settings or by
          contacting us. We retain personal data for the necessary period
          required for its intended purpose or as mandated by law. Data may be
          anonymized for analytical purposes.
        </p>

        <h3 className="mb-2" style={{ fontWeight: 600, fontSize: "24px" }}>
          Your Rights
        </h3>
        <p className="mb-4">
          You have the right to access, rectify, update, or delete your personal
          data. Requests can be made directly on the Platform or through our
          contact information.
        </p>

        <h3 className="mb-2" style={{ fontWeight: 600, fontSize: "24px" }}>
          Consent
        </h3>
        <p className="mb-4">
          By using our Platform, you consent to the collection, use, and
          processing of your personal data as described in this Privacy Policy.
          You can withdraw your consent by contacting the Grievance Officer, but
          note that this may restrict your access to certain services.
        </p>

        <h3 className="mb-2" style={{ fontWeight: 600, fontSize: "24px" }}>
          Changes to this Privacy Policy
        </h3>
        <p className="mb-4">
          We may update this Privacy Policy from time to time to reflect changes
          in our practices or legal requirements. Significant changes will be
          communicated as required by applicable laws.
        </p>

        <h3 className="mb-2" style={{ fontWeight: 600, fontSize: "24px" }}>
          Grievance Officer
        </h3>
        <p className="mb-4">
          <strong>Name:</strong> {process.env.REACT_APP_FAM}
          <br />
          <strong>Designation:</strong> Proprietor
          <br />
          <strong>Address:</strong> {process.env.REACT_APP_ADDRESS}
          <br />
          <strong>Contact:</strong> support@
          {getBaseDomain(window.location.hostname)}, Phone:{" "}
          {process.env.REACT_APP_MO}
          <br />
          <strong>Hours:</strong> Monday - Saturday (10:00 AM - 6:00 PM)
        </p>
      </div>

      <div className="text-center mt-6">
        <h3
          style={{
            fontSize: "18px",
            fontWeight: 700,
            color: "#727272",
            textAlign: "center",
          }}
        >
          Get Our Newsletter
        </h3>
        <div className="Footer__Content Rte">
          Subscribe to receive updates, access to exclusive deals, and more.
        </div>
        <Form
          method="post"
          id="footer-newsletter"
          acceptCharset="UTF-8"
          className="my-3"
          onSubmit={handleSubscribe}
        >
          <input type="hidden" name="form_type" value="customer" />
          <input type="hidden" name="utf8" value="✓" />
          <input type="hidden" name="contact[tags]" value="newsletter" />

          <Form.Control
            size="lg"
            type="email"
            placeholder="Enter email"
            className="mb-3"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          {!subscribed && (
            <Button
              type="submit"
              variant="dark"
              className="mt-3"
              style={{
                background: "var(--them-color)",
                borderColor: "var(--them-color)",
              }}
            >
              Subscribe
            </Button>
          )}

          {message && (
            <p style={{ color: "green", marginTop: "10px", fontWeight: 500 }}>
              {message}
            </p>
          )}
        </Form>
      </div>
    </Container>
  );
};

export default PrivacyPolicy;
